import type { CSSProperties } from "react";

interface PlaceholderProps {
  label?: string;
  height?: number | string;
  width?: number | string;
  dark?: boolean;
  className?: string;
  style?: CSSProperties;
}

/**
 * Striped placeholder (135° gradient) — matches shared/atoms.jsx.
 * Used anywhere a real image will eventually go.
 */
export function Placeholder({
  label = "imagen",
  height = 280,
  width = "100%",
  dark = false,
  className = "",
  style,
}: PlaceholderProps) {
  const stripeClass = dark
    ? "taller-placeholder-dark"
    : "taller-placeholder-light";

  return (
    <div
      className={`relative overflow-hidden ${stripeClass} ${className}`}
      style={{ width, height, ...style }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className="font-mono text-[10px] uppercase tracking-[0.22em]"
          style={{
            background: dark ? "rgba(0,0,0,.6)" : "rgba(255,255,255,.85)",
            padding: "4px 10px",
            borderRadius: dark ? 0 : 2,
            border: dark ? "1px solid rgba(255,255,255,.15)" : "none",
            color: dark ? "rgba(255,255,255,.55)" : "rgba(0,0,0,.5)",
          }}
        >
          [ {label} ]
        </span>
      </div>
    </div>
  );
}
